/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
// eslint-disable-next-line no-unused-vars
import { css, jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import * as d3 from 'd3';
import { D3Legend } from './D3Legend';
import { Colors } from 'styles/variables';

/**
 * Responsible for rendering a Legend to support widgets.
 *
 * Expects data in the form:
 * [{key: key, value: value}, ...]
 * @param dimensions {{height: height, width: width}}
 * @param data Array of {key: key, value: value}
 * @param colorScale
 * @param minBarWidth
 * @param mouseOver
 * @param mouseOut
 * @returns {*}
 * @constructor
 */
export const Legend = ({ dimensions, data, colorScale, minBarWidth = 10, mouseOver, mouseOut }) => {
	const svgRef = useRef();
	const { height, width } = dimensions;
	const [chart, setChart] = useState();

	// creates a series which has a range for each key
	// [0, value1], [value1: value1 + value2]...
	const series = useMemo(() => {
		// convert to {key1: value1, key2: value2...}
		const reduced = data.reduce((prev, current) => {
			prev[current.key] = current.value;
			return prev;
		}, {});

		// gets all the keys [key1, key2...]
		const keys = Object.keys(reduced);
		const stack = d3.stack().keys(keys);
		return stack([reduced]);
	}, [data]);

	// determine average bar width
	const averageWidth = useMemo(() => {
		return dimensions.width / data.length;
	}, [data, dimensions]);

	useEffect(() => {
		const createChart = () => {
			return D3Legend(svgRef.current);
		};

		if (series && dimensions && colorScale) {
			let ch = chart;

			// if we don't have an existing chart, create one
			if (!ch) {
				ch = createChart();
				setChart(ch);
			}

			ch.update(series, dimensions, colorScale, mouseOver, mouseOut);
		}
	}, [dimensions, colorScale, series, mouseOver, mouseOut, chart]);

	// currently we don't render the bar if there are too many elements to show reasonably.

	return (
		<div css={containerStyle}>
			<svg css={svgStyle} width={width} height={height} ref={svgRef} />

			{averageWidth <= minBarWidth && (
				<div
					css={css`
						${noLegend};
						height: ${height}px;
					`}
				>
					Legend Not Available: Too Many Entries
				</div>
			)}
		</div>
	);
};

const containerStyle = css`
	position: relative;
`;

const svgStyle = css`
	position: absolute;
	top: 0;
`;

const noLegend = css`
	background-color: ${Colors.LIGHT_GRAY2};
	width: 100%;
	position: absolute;
	top: 0;
	padding: 10px;
`;

Legend.propTypes = {
	data: PropTypes.any, // either a hierarchy or flat array.
	dimensions: PropTypes.object,
	colorScale: PropTypes.any, //TODO: is this PropTypes.func ??
};
